import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const BackToTop = ({ show, onClick }) => {
  if (!show) {
    return null;
  }

  const handleClick = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className="back-to-top-button"
      onClick={handleClick}
      aria-label="Back to top"
      title="Back to top"
    >
      <FontAwesomeIcon icon={faArrowUp} />
    </button>
  );
};

export default BackToTop;

